import share from '@/api/share';

import { FETCH_SHARE, FETCH_COURSE, FETCH_TIMES, BIND_SHARE, REQUEST_SHARE_BINDING } from './types';

export default {
    [FETCH_SHARE]({ commit }, payload) {
        return share
            .get(payload.hash)
            .then(resp => commit(FETCH_SHARE, resp));
    },
    [FETCH_COURSE]({ commit }, payload) {
        return share
            .getCourse(payload.hash)
            .then(resp => commit(FETCH_COURSE, resp));
    },
    [FETCH_TIMES]({ commit }, payload) {
        return share
            .getTimes(payload.hash)
            .then(resp => commit(FETCH_TIMES, resp));
    },
    [BIND_SHARE]({ commit }, payload) {
        return share
            .bind(payload.hash)
            .then(resp => commit(BIND_SHARE, resp));
    },
    [REQUEST_SHARE_BINDING]({ commit }, payload) {
        return share
            .request(payload.hash, {
                message: payload.message,
            })
            .then(resp => commit(REQUEST_SHARE_BINDING, resp));
    },
};



// WEBPACK FOOTER //
// ./src/store/share/actions.js